 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab":"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab","Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course","Admin":"Admin","List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course","List-Students":"List-Students","List-Trainers":"List-Trainers","add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting":"add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting","add faq":"add faq","detail course":"detail course","faq":"faq","list courses":"list courses","studentCourse":"studentCourse","trainer course":"trainer course","add Trainer":"add Trainer","add course~edit course":"add course~edit course","add course":"add course","edit course":"edit course","edit Trainer":"edit Trainer","setting":"setting","studentID":"studentID","Login":"Login"}[chunkId]||chunkId) + "." + {"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab":"f2282c82","Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"2d769283","Admin":"443cab00","List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"2f4ff160","List-Students":"52bdcdac","List-Trainers":"639b74a2","add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting":"0cc0622f","add faq":"2db0d23e","detail course":"23eb3245","faq":"f29506c8","list courses":"58b67523","studentCourse":"567eaffd","trainer course":"cc5d41cc","add Trainer":"699e6a88","add course~edit course":"c45a5a8e","add course":"8722353f","edit course":"9fd4f3f9","edit Trainer":"c8d4ff48","setting":"2e97004f","studentID":"83ee1de2","Login":"38501f4b","chunk-d22e7536":"206e722e","chunk-47c34c0a":"241a62ba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab":1,"Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":1,"Admin":1,"List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":1,"List-Students":1,"List-Trainers":1,"add faq":1,"detail course":1,"faq":1,"list courses":1,"studentCourse":1,"trainer course":1,"add Trainer":1,"add course":1,"edit course":1,"edit Trainer":1,"setting":1,"studentID":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab":"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab","Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course","Admin":"Admin","List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course","List-Students":"List-Students","List-Trainers":"List-Trainers","add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting":"add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting","add faq":"add faq","detail course":"detail course","faq":"faq","list courses":"list courses","studentCourse":"studentCourse","trainer course":"trainer course","add Trainer":"add Trainer","add course~edit course":"add course~edit course","add course":"add course","edit course":"edit course","edit Trainer":"edit Trainer","setting":"setting","studentID":"studentID","Login":"Login"}[chunkId]||chunkId) + "." + {"Admin~List-Students~List-Trainers~add Trainer~add course~add faq~detail course~edit Trainer~edit cou~1d3f3cab":"6db9b336","Admin~List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"7c593073","Admin":"fb8c70df","List-Students~List-Trainers~add faq~detail course~faq~list courses~studentCourse~trainer course":"aa3a36d6","List-Students":"10a0d4f1","List-Trainers":"4d3fd097","add Trainer~add course~add faq~detail course~edit Trainer~edit course~setting":"31d6cfe0","add faq":"e6bac924","detail course":"8144d1c1","faq":"7862fe5d","list courses":"3485f019","studentCourse":"78f779e4","trainer course":"32fa8eac","add Trainer":"28cde9f4","add course~edit course":"31d6cfe0","add course":"17dd046c","edit course":"87c39aea","edit Trainer":"0c073b7e","setting":"221a967f","studentID":"b3dce8c1","Login":"31d6cfe0","chunk-d22e7536":"31d6cfe0","chunk-47c34c0a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
